import { useEffect, useState } from "react";
import {
    makeStyles
} from "@mui/styles";
import {
    Grid
} from '@mui/material';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';

const useStyles = makeStyles({
    middleSection: {
        borderLeft: "1px solid #D1D1D1",
        borderRight: "1px solid #D1D1D1"
    },
    middleHeader: {
        height: "74px",
        padding: "0px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0px 2px 4px 0px #D1D1D140"
    },
    headerLeftSection: {
        display: "flex",
        alignItems: "flex-start"
    },
    headerRightSection: {
        display: "flex",
        alignItems: "center"
    },
    userView: {
        marginLeft: 10
    },
    username: {
        margin: 0,
        fontSize: 14,
        fontWeight: "bold"
    },
    lastSeen: {
        margin: 0,
        fontSize: 12,
        color: "#ABABAB"
    },
    callIcon: {
        height: 20,
        cursor: "pointer"
    },
    moreIcon: {
        marginLeft: 10,
        height: 24,
        cursor: "pointer"
    },
    profile: {
        borderRadius: "50px",
        background: "linear-gradient(180deg,#d92cc1,#4D72F8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "35px",
        width: "35px"
    },
    profileSymbol: {
        color: "white"
    },
    bottomSection: {
        position: "relative"
    },
    chatDateTime: {
        fontSize: "12px",
        margin: "0px",
        textAlign: "center",
        color: "#818080CC",
        position: "absolute",
        left: "50%",
        top: "10px",
        transform: "translate(-50%)",
        backgroundColor: "#EFF1F2",
        borderRadius: "7px",
        padding: "5px 12px",
        zIndex: 1
    },
    chatSection: {
        padding: "20px",
        paddingTop: "30px",
        height: "calc(100vh - 164px)",
        overflowY: "scroll"
    },
    messageView: {
        marginTop: "10px",
        backgroundColor: "#E9EFF4",
        display: "flex",
        width: "fit-content",
        borderRadius: "50px",
        padding: "15px 20px"
    },
    receiverMessageView: {
        marginLeft: "auto",
        background: "linear-gradient(180deg,#d92cc1,#4D72F8)",
        boxShadow: "0px 1px 7px 0px #00000040",
        color: "white"
    },
    topLeftCurve: {
        borderTopLeftRadius: "75px",
        borderBottomLeftRadius: "0px"
    },
    bottomLeftCurve: {
        borderBottomLeftRadius: "75px",
        borderTopLeftRadius: "0px"
    },
    leftCurveNone: {
        borderTopLeftRadius: "0px",
        borderBottomLeftRadius: "0px"
    },
    topRightCurve: {
        borderTopRightRadius: "75px",
        borderBottomRightRadius: "0px"
    },
    bottomRightCurve: {
        borderBottomRightRadius: "75px",
        borderTopRightRadius: "0px"
    },
    rightCurveNone: {
        borderTopRightRadius: "0px",
        borderBottomRightRadius: "0px"
    },
    message: {
        margin: "0px",
        fontSize: "14px"
    },
    timeView: {
        width: "60px",
        position: "relative"
    },
    time: {
        margin: "0px",
        fontSize: "10px",
        position: "absolute",
        right: "0px",
        bottom: "-5px"
    },
    form: {
        width: "100%"
    },
    sendMessageRow: {
        display: "flex",
        alignItems: "center",
        padding: "20px",
        boxShadow: "0px 0px 15px 7px #D1D1D140"
    },
    attachIcon: {
        height: "25px",
        cursor: "pointer"
    },
    typeMessageBox: {
        backgroundColor: "#F0F2F5",
        borderRadius: "10px",
        width: "100%",
        overflow: "hidden",
        position: "relative"
    },
    input: {
        padding: "17px 20px",
        border: "none",
        backgroundColor: "#F0F2F5",
        width: "100%",
        "&:focus-visible": {
            outline: "none"
        }
    },
    voiceIcon: {
        color: "#818080CC",
        position: "absolute",
        top: "50%",
        right: "5px",
        transform: "translate(0%, -50%)",
        cursor: "pointer"
    },
    sendBtn: {
        cursor: "pointer",
        padding: "0px",
        background: "white",
        border: "none"
    },
    sendBtnIcon: {
        height: "45px"
    }
});

const MiddleSection = () => {
    const classes = useStyles();
    
    useEffect(() => {
        
    }, []);

    return (
        <>
            <Grid className={classes.middleSection}>
                <Grid className={classes.middleHeader}>
                    <Grid className={classes.headerLeftSection}>
                        <Grid className={classes.profile}>
                            <p className={classes.profileSymbol}>MI</p>
                        </Grid>
                        <Grid className={classes.userView}>
                            <p className={classes.username}>Mishal Irfan</p>
                            <p className={classes.lastSeen}>Last seen at 2:34 pm</p>
                        </Grid>
                    </Grid>
                    <Grid className={classes.headerRightSection}>
                        <img
                            src={require("../../assets/icons/call.png")}
                            className={classes.callIcon}
                        />
                        <img
                            src={require("../../assets/icons/menuvertical.png")}
                            className={classes.moreIcon}
                        />
                    </Grid>
                </Grid>
                <Grid className={classes.bottomSection}>
                    <p className={classes.chatDateTime}>Today 12:34 PM</p>
                    {/* CHAT SECTION START */}
                    <Grid className={classes.chatSection}>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                                <Grid className={classes.messageView}>
                                    <Grid>
                                        <p className={classes.message}>Hello, how are you? available for meeting?</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid>
                                    <p></p>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.receiverMessageView, classes.topRightCurve]}>
                                    <Grid>
                                        <p className={classes.message}>Hello</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.receiverMessageView, classes.rightCurveNone]}>
                                    <Grid>
                                        <p className={classes.message}>O asjd ja sdjhas djhask?</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.receiverMessageView, classes.bottomRightCurve]}>
                                    <Grid>
                                        <p className={classes.message}>O asjd ja sdjhas djhask?</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.topLeftCurve]}>
                                    <Grid>
                                        <p className={classes.message}>Hello</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid>
                                    <p></p>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.leftCurveNone]}>
                                    <Grid>
                                        <p className={classes.message}>Hello, how are you? available for meeting?</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid>
                                    <p></p>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.bottomLeftCurve]}>
                                    <Grid>
                                        <p className={classes.message}>Hello, how are you? available for meeting?</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid>
                                    <p></p>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.receiverMessageView]}>
                                    <Grid>
                                        <p className={classes.message}>Hello</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                                <Grid className={classes.messageView}>
                                    <Grid>
                                        <p className={classes.message}>Hello</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.receiverMessageView, classes.bottomRightCurve]}>
                                    <Grid>
                                        <p className={classes.message}>O asjd ja sdjhas djhask?</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.topLeftCurve]}>
                                    <Grid>
                                        <p className={classes.message}>Hello</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid>
                                    <p></p>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.leftCurveNone]}>
                                    <Grid>
                                        <p className={classes.message}>Hello, how are you? available for meeting?</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid>
                                    <p></p>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container>
                            {/* Sender */}
                            <Grid xs={6}>
                                <Grid className={[classes.messageView, classes.bottomLeftCurve]}>
                                    <Grid>
                                        <p className={classes.message}>Hello, how are you? available for meeting?</p>
                                    </Grid>
                                    <Grid className={classes.timeView}>
                                        <p className={classes.time}>2:30 PM</p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Receiver */}
                            <Grid xs={6}>
                                <Grid>
                                    <p></p>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* CHAT SECTION END */}
                    {/* SEND MESSAGE ROW START */}
                    <Grid className={classes.sendMessageRow}>
                        <img
                            src={require("../../assets/icons/attach.png")}
                            className={classes.attachIcon}
                        />
                        <form className={classes.form}>
                            <Grid className={classes.typeMessageBox}>
                                <input
                                    type="text"
                                    placeholder="Type Message Here..."
                                    className={classes.input}
                                />
                                <KeyboardVoiceIcon
                                    className={classes.voiceIcon}
                                />
                            </Grid>
                        </form>
                        <button
                            type="submit"
                            className={classes.sendBtn}
                        >
                            <img
                                src={require("../../assets/icons/send.png")}
                                className={classes.sendBtnIcon}
                            />
                        </button>
                    </Grid>
                    {/* SEND MESSAGE ROW END */}
                </Grid>
            </Grid>

        </>
    )
}

export default MiddleSection;